<script>
    import {M} from "../../external";

    export let approveClick, denyClick;
</script>
<div class="approve-buttons">
    <a rel="action" data-action="approveMember" on:click={approveClick} class="green middle-button">{M.APPROVE}</a>
    <a rel="action" data-action="denyMember" on:click={denyClick} class="deny-button">{M.DENY}</a>
</div>